import { ref } from 'vue'
import {
  fetchAdminProducts,
  type ProductStatusCounts,
} from '@/api/admin'
import type { ServerMallProduct } from '@/api/mallProduct'

/**
 * 관리자 화면이 함께 보는 상품 상태.
 * 검수 대기 건수는 사이드바 배지에도 쓰이므로 모듈 스코프에 둔다.
 */
const products = ref<ServerMallProduct[]>([])
const counts = ref<ProductStatusCounts>({})
const loading = ref(false)
const errorMessage = ref('')
const toast = ref('')

let toastTimer: ReturnType<typeof setTimeout> | undefined

export function useAdminProducts() {
  const load = async (query: { status?: string; keyword?: string } = {}) => {
    loading.value = true
    errorMessage.value = ''

    try {
      const result = await fetchAdminProducts(query)
      products.value = result.products
      counts.value = result.counts
    } catch (error) {
      errorMessage.value = error instanceof Error ? error.message : '상품을 불러오지 못했습니다.'
      products.value = []
    } finally {
      loading.value = false
    }
  }

  const notify = (message: string) => {
    toast.value = message
    window.clearTimeout(toastTimer)
    toastTimer = setTimeout(() => {
      toast.value = ''
    }, 2600)
  }

  return { products, counts, loading, errorMessage, toast, load, notify }
}
